let currentScrollTop = 0;
let previousScrollTop = 0;
let isScrollingUp = false;

const handleWindowScroll = () => {
  currentScrollTop = window.scrollY;
  isScrollingUp = currentScrollTop <= previousScrollTop;
  previousScrollTop = currentScrollTop;
};

window.addEventListener('scroll', () => {
  handleWindowScroll();
});

if(document.body.classList.contains('page-template-page-programma')) {
  const main = document.querySelector('main');

  main.style.position = 'relative';

  window.addEventListener('scroll', () => {
    const map = document.querySelector('[data-map-container]');

    if(map) {
      if(window.scrollY > main.offsetHeight - window.innerHeight) {
        map.style.position = 'absolute';
        map.style.top = 'auto';
        map.style.bottom = 0;
      } else {
        map.style.position = 'fixed';
        map.style.top = 'var(--navigation-size)';
        map.style.bottom = 'auto';
      }
    }
  });
}

const setupComponentScrollTrigger = (componentElement, timeline, start = 'top bottom', end = 'bottom top') => {
  ScrollTrigger.create({
    scroller: document.documentElement,
    trigger: componentElement,
    start,
    end,
    onEnter: () => timeline.play(),
  });
};